import React from "react";
import { ArrowRight, Lock, Sparkles } from "lucide-react";

export default function HeroSection({ onExploreClick }) {
  return (
    <section className="relative overflow-hidden pt-8 pb-14 lg:py-16 border-b border-white/10">
      {/* Subtle Glow */}
      <div className="absolute top-1/3 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[250px] bg-[#FF8C69]/10 blur-[120px] pointer-events-none rounded-full" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
          
          {/* Left Text Content */}
          <div className="lg:col-span-7 space-y-6 text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-[#121214] border border-white/10 text-xs font-bold text-[#FF8C69]">
              <Sparkles className="w-3.5 h-3.5" />
              <span>Coleções Oficiais</span>
            </div>

            <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-bold leading-[1.1] text-white">
              Produtos Exclusivos <br />
              <span className="text-[#FF8C69]">Joyce</span> para você.
            </h1>

            <p className="text-sm sm:text-base text-[#A1A1AA] max-w-xl leading-relaxed">
              Catálogo oficial de moda íntima, fragrâncias e acessórios selecionados. Compre com total privacidade, segurança e entrega rápida em todo o Brasil.
            </p>

            <div className="pt-2 flex flex-wrap items-center gap-4">
              <button
                onClick={onExploreClick}
                data-testid="hero-explore-btn"
                className="px-8 py-3.5 rounded-xl bg-[#FF8C69] hover:bg-[#FFA285] text-[#0A0A0B] text-xs sm:text-sm font-bold tracking-wider uppercase shadow-[0_4px_25px_rgba(255,140,105,0.3)] transition-all flex items-center gap-2"
              >
                <span>Ver Catálogo</span>
                <ArrowRight className="w-4 h-4" />
              </button>

              <div className="flex items-center gap-2 px-4 py-3 rounded-xl bg-[#121214] border border-white/10 text-xs text-[#A1A1AA]">
                <Lock className="w-4 h-4 text-[#FF8C69]" />
                <span>Embalagem 100% discreta e sem marcas</span>
              </div>
            </div>

          </div>

          {/* Right Brand Card */}
          <div className="lg:col-span-5 relative">
            <div className="relative rounded-3xl p-8 border border-white/10 shadow-2xl bg-[#121214] flex flex-col justify-center items-center text-center space-y-4">
              <img
                src="/logo.png"
                alt="Joyce SXY"
                className="h-28 w-auto object-contain"
              />
              <h3 className="font-heading text-2xl font-bold text-[#FF8C69]">
                Joyce SXY
              </h3>
              <p className="text-xs text-[#A1A1AA] max-w-xs leading-relaxed">
                Ambiente de compras oficial, integrado e com proteção de ponta a ponta.
              </p>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
